import { useState } from 'react';

import UserAppRoleSelect from 'Components/Common/UserAppRoleSelect/UserAppRoleSelect';
import { UserRole } from 'api/dtos/user';
import { useUpdateUserRoleMutation } from 'api/entityEndpoints';
import useGetCurrentEntityId from 'hooks/useGetCurrentEntityId';

type Props = {
    id: string;
    role: UserRole;
}

const TeamMemberAppRole = ({
    id,
    role,
}: Props) => {
    const [updateRole, { isLoading, isError }] = useUpdateUserRoleMutation();
    const currentEntityId = useGetCurrentEntityId();
    const [selectedRole, setSelectedRole] = useState(role);

    const updateUserAppRole = async (updatedRole: UserRole, callback?: () => void) => {
        if (!currentEntityId) {
            return;
        }

        const previousRole = selectedRole;
        setSelectedRole(updatedRole);

        try {
            await updateRole({
                entityId: currentEntityId,
                userId: id,
                role: {
                    role: updatedRole,
                },
            }).unwrap();

            callback?.();
        } catch (e: any) {
            setSelectedRole(previousRole);
            console.log(e); // TO_DO
        }
    };

    return (
        <UserAppRoleSelect id={id} role={selectedRole} isError={isError} isLoading={isLoading} onSelectRole={updateUserAppRole} />
    );
};

export default TeamMemberAppRole;
